import InputField from "../../../../Forms/Input/InputField";

interface Props {
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}

const NumberFilterField: React.FC<Props> = ({ name, label, value, onChange }) => (
  <InputField
    label={label}
    name={name}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder="0.00"
    type="number"
    step="0.01"
    iconKey="dollar"
    min={0}
  />
);

export default NumberFilterField;
